module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/slider/image15-fe66b4f0a2efc5ea0b5bee619f71e4c5.jpg";